import {DateRangePicker} from '@hconnect/uikit/src/lib2'
import {Theme, useMediaQuery} from '@mui/material'
import React from 'react'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../../../consts'
import {useTimeRangeParam, getQuickSelectionItems} from '../../../hooks'

type DateTimeRangePickerProps = {
  disableCustomSelect?: boolean
  disabled?: boolean
  onDateRangeChange?: () => void
  timezone: string
}

export const DateTimeRangePicker: React.FC<DateTimeRangePickerProps> = ({
  disableCustomSelect,
  disabled,
  onDateRangeChange,
  timezone
}) => {
  const {t} = useTranslation(FEATURE_NAMESPACE)
  const [timeRange, setTimeRange] = useTimeRangeParam()

  const onTimeRangeParamChange = (param: string) => {
    setTimeRange(param)
    onDateRangeChange?.()
  }

  const selectionItems = getQuickSelectionItems(t, timezone, new Date())

  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'))
  const singleDateSwitchLabel = t('quickSelection.pickSingleDate')

  return (
    <DateRangePicker
      onTimeRangeParamChange={onTimeRangeParamChange}
      timeRangeParam={timeRange}
      singleDateSwitchLabel={singleDateSwitchLabel}
      selectionItems={selectionItems}
      timezone={timezone}
      disableCustomSelect={disableCustomSelect}
      fullWidth={isMobile}
      withForm={true}
      disabled={disabled}
      isContrastMode={false}
    />
  )
}
